module.exports = __webpack_public_path__ + "img/finished_back.fd6a9cd9.svg";